/**
 * A form for someone who may read it but not change it. The fields keep their
 * layout and full-strength text, still selectable so an Aktenzeichen can be
 * copied, but lose what makes them look editable: the filled tint, the
 * underline, the placeholder and the buttons inside them. An empty field shows
 * a dash, so a blank reads as "nothing recorded" rather than as a gap.
 *
 * Goes on the element around the form; the fields themselves are `readOnly`.
 * The date pickers draw their own input (`MuiPickersFilledInput`), so each
 * rule names both.
 */
export const readOnlySheetSx = {
    '& .MuiFilledInput-root, & .MuiFilledInput-root:hover, & .MuiFilledInput-root.Mui-focused, & .MuiPickersFilledInput-root, & .MuiPickersFilledInput-root:hover, & .MuiPickersFilledInput-root.Mui-focused':
        {
            bgcolor: 'transparent'
        },
    '& .MuiFilledInput-root::before, & .MuiFilledInput-root::after, & .MuiPickersFilledInput-root::before, & .MuiPickersFilledInput-root::after':
        {
            display: 'none'
        },
    '& .MuiInputLabel-root.Mui-focused': { color: 'text.secondary' },

    // An empty field keeps its label up where a filled one has it: lowered
    // into the value's place, a label reads as if it were the value.
    '& .MuiInputLabel-root[data-shrink="false"]': {
        transform: 'translate(12px, 7px) scale(0.75)'
    },
    /**
     * The dash, keyed on the same flag: MUI lowers the label exactly while a
     * field — text, select, picker or chips alike — is empty and unfocused.
     * Placed where the filled input draws its value (12px in, 25px down).
     */
    '& .MuiFormControl-root:has(> .MuiInputLabel-root[data-shrink="false"])::after':
        {
            content: '"—"',
            position: 'absolute',
            left: 12,
            top: 25,
            typography: 'body1',
            lineHeight: '1.4375em',
            color: 'text.secondary',
            pointerEvents: 'none'
        },
    // The long texts carry their dash as a placeholder (see RichTextArea), so
    // only the filled inputs' own placeholders go.
    '& .MuiFilledInput-input::placeholder': { opacity: 0 },
    '& .MuiAutocomplete-endAdornment, & .MuiSelect-icon, & .MuiInputAdornment-root .MuiIconButton-root':
        {
            display: 'none'
        },
    '& .MuiSelect-select, & .MuiAutocomplete-inputRoot': { cursor: 'text' },
    '& .MuiCheckbox-root': { pointerEvents: 'none' }
};
